import { NavLink, Outlet, useLocation } from "react-router-dom";
import type { Permission } from "../types/api";
import { useAuth } from "../services/auth";

const navItems: Array<{ to: string; label: string; permission: Permission }> = [
  { to: "/indicadores", label: "Indicadores", permission: "dashboard" },
  { to: "/analise-grafica", label: "Análise Gráfica", permission: "graficos" },
  { to: "/evasao", label: "Evasão", permission: "evasao" },
  { to: "/questionarios", label: "Questionários", permission: "questionario" },
  { to: "/prova-facil", label: "Prova Fácil", permission: "prova-facil" },
  { to: "/usuarios", label: "Usuários", permission: "usuarios" }
];

const wideDashboardPaths = new Set(navItems.map((item) => item.to));

export function AppShell() {
  const { profile, hasPermission, logout } = useAuth();
  const { pathname } = useLocation();
  const isWideDashboard = wideDashboardPaths.has(pathname);

  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="app-header__content">
          <div className="brand">
            <img src="/logo-mackenzie-ead.png" alt="Universidade Presbiteriana Mackenzie" />
            <div
              className="brand__institutions"
              title="PRGA: Pró-Reitoria de Graduação | CEDUC: Coordenadoria de Apoio Acadêmico e Tecnologia Educacional"
            >
              <div className="brand__unit">
                <strong>PRGA</strong>
                <span>Pró-Reitoria de Graduação</span>
              </div>
              <span className="brand__divider" aria-hidden="true" />
              <div className="brand__unit">
                <strong>CEDUC</strong>
                <span>Coordenadoria de Apoio Acadêmico e Tecnologia Educacional</span>
              </div>
            </div>
          </div>
          <div className="user-menu">
            <div className="user-menu__identity">
              <span>Usuário conectado</span>
              <strong>{profile?.name || "Usuário"}</strong>
            </div>
            <button type="button" onClick={() => void logout()}>Sair</button>
          </div>
        </div>
      </header>

      <div className="top-nav-wrap">
        <nav className="top-nav" aria-label="Navegação principal">
          {navItems.filter((item) => hasPermission(item.permission)).map((item) => (
            <NavLink key={item.to} to={item.to}>{item.label}</NavLink>
          ))}
        </nav>
      </div>

      <main className={`content${isWideDashboard ? " content--wide" : ""}`}>
        <Outlet />
      </main>
    </div>
  );
}
